import { useTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { FloppyDiskIcon, LinkBackwardIcon } from '@hugeicons-pro/core-bulk-rounded/index'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'

import AppToolbar from './AppToolbar'

const SettingsToolbar = ({
    enableCancelButton = false,
    enableSaveButton = false,
    handleCancelClick,
    handleSaveClick,
    isLoading = false,
}) => {
    const { t } = useTranslation()

    return (
        <AppToolbar>
            <Button
                color="secondary"
                data-testid="reset-settings"
                disabled={!enableCancelButton || isLoading}
                startIcon={<HugeiconsIcon icon={LinkBackwardIcon} />}
                variant="outlined"
                onClick={handleCancelClick}
            >
                {t('Cancel')}
            </Button>

            <Button
                color="primary"
                data-testid="save-settings"
                disabled={!enableSaveButton}
                loading={isLoading}
                loadingPosition="start"
                startIcon={<HugeiconsIcon icon={FloppyDiskIcon} />}
                variant="contained"
                onClick={handleSaveClick}
            >
                {isLoading ? t('Saving') : t('Save changes')}
            </Button>
        </AppToolbar>
    )
}

SettingsToolbar.propTypes = {
    handleCancelClick: PropTypes.func.isRequired,
    handleSaveClick: PropTypes.func.isRequired,
    enableCancelButton: PropTypes.bool,
    enableSaveButton: PropTypes.bool,
    isLoading: PropTypes.bool,
}

export default SettingsToolbar
